import { render } from "./Main.vue?vue&type=template&id=cb38fb46&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=cb38fb46&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cb38fb46"

export default script